import { Tab } from 'semantic-ui-react';
import { useState } from '@wordpress/element';
import Population from './Population';
import Group from './Group';

const Tabs = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const handleRangeChange = e => setActiveIndex(e);
    const handleTabChange = (e, { activeIndex }) => setActiveIndex(activeIndex);

    const panes = [
        {
            menuItem: 'Population Totals',
            render: () => (
                <Tab.Pane>
                    <Population handleRangeChange={handleRangeChange} />
                </Tab.Pane>
            ),
        },
        {
            menuItem: 'Selected Characteristics',
            render: () => (
                <Tab.Pane>
                    <Group handleRangeChange={handleRangeChange} />
                </Tab.Pane>
            ),
        },
    ];

    return (
        <>
            <Tab
                panes={panes}
                activeIndex={activeIndex}
                handleRangeChange={handleRangeChange}
                onTabChange={handleTabChange}
            />
            {/* <div className="Source">
                Source: Pew Research Center analysis of 2013-2015 American
                Community Survey (IPUMS).
            </div> */}
        </>
    );
};

export default Tabs;
